import { createContext } from 'libs/createContext'

const {
  Provider: HelpdeskIntegrationProvider,
  Consumer: HelpdeskIntegrationConsumer,
  withContext: withHelpdeskIntegrationContext,
} = createContext({
  updatePrimaryIntegration: () => {},
})

export { HelpdeskIntegrationProvider, HelpdeskIntegrationConsumer, withHelpdeskIntegrationContext }



// WEBPACK FOOTER //
// ./node_modules/eslint-loader??ref--0-0!./src/organisms/HelpdeskIntegration/context.js